<template lang="pug">
  div
    .sw-markdown-textarea(v-if="displayMarkdown")
      .cursor-pointer.overflow-auto.h-48.pb-10(
        :class="customClasses"
        @click="focusOnInput"
        v-html="markedNote"
      )
    textarea.transition.duration-200.ease-out(
      v-else
      ref="input"
      :class="customClasses"
      :placeholder="placeholder"
      :rows="numberOfRows"
      :value="value"
      @blur="handleBlur()"
      @focus="$emit('focus')"
      @input="$emit('input', $event.target.value)"
    )
</template>

<script>
import marked from 'marked';
export default {
  name: 'SwMarkdownTextarea',
  props: {
    value: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    customClasses: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      displayMarkdown: true,
    };
  },
  computed: {
    markedNote () {
      return marked(this.value || '', { breaks: true });
    },
    numberOfRows () {
      if (!this.value) return 10;
      // Calculates the number of rows needed for the client comment on the basis of an
      // 33 char length of the client comment input field
      const lines = this.value.split(/\r\n|\r|\n/);
      const longLines = lines.filter(line => line.length > 33);
      const lengthBreaks = longLines.reduce((tot, line) => tot + Math.ceil(line.length / 33), 0);
      return Math.max(lengthBreaks + lines.length - longLines.length, 10);
    },
  },
  methods: {
    focusOnInput () {
      this.displayMarkdown = false;
      this.$nextTick(() => this.$refs.input.focus());
    },
    handleBlur () {
      this.displayMarkdown = true;
      this.$emit('blur');
    },
  },
};
</script>
